export const basemaps = [
  {
    id: 'light',
    name: 'Light',
  },
  {
    id: 'dark',
    name: 'Dark'
  },
  {
    id: 'satellite',
    name: 'Satellite'
  }
];

export default { basemaps };
